import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

interface HeaderProps {
    isOpen: boolean;
}

export const Header = styled.div<HeaderProps>`
    background: ${(props) => (props.isOpen ? theme.colors.accent.background : theme.colors.background.subtle)};
    border: 1px solid ${(props) => (props.isOpen ? theme.colors.accent.border : theme.colors.border.muted)};
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border-bottom-left-radius: ${(props) => (props.isOpen ? '0px' : '6px')};
    border-bottom-right-radius: ${(props) => (props.isOpen ? '0px' : '6px')};

    padding: 8px 16px;
    height: 64px;
    cursor: pointer;
    display: grid;
    grid-template-columns: 1fr auto;
    grid-column-gap: 12px;
    align-items: center;
    transition:
        background 200ms,
        border 200ms;
`;
